import React from 'react';
import { motion } from 'framer-motion';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper';
import { FaCalendarAlt, FaMapMarkerAlt, FaArrowRight } from 'react-icons/fa';
import 'swiper/css';
import 'swiper/css/navigation';

// Import event images
import roboticsChallenge from '../../assets/images/coming_events/rc c.jpg';
import stemWorkshop from '../../assets/images/coming_events/stemworkshop.jpg';
import schoolWorkshop from '../../assets/images/coming_events/scl.jpg';
import robotCompetition from '../../assets/images/coming_events/rbot.jpg';
import olRobotics from '../../assets/images/coming_events/ol.jpg';
import threeDesign from '../../assets/images/coming_events/3d.jpg';

// Placeholder event data - in a real app this would come from an API or CMS
const events = [
  {
    id: 1,
    title: 'Online All Island Robotics Challenge 2021',
    date: 'February 02 Tuesday, 2021',
    location: 'STEM Labs - Delkanda',
    description: 'Specially designed to gather new Innovators to the STEM Labs with new innovative ideas.',
    image: roboticsChallenge,
    link: 'https://docs.google.com/forms/d/e/1FAIpQLSfP6lqznlJRU_mQCkkUrxNPNMNRVuJThBLgX93pKc3TXjawwQ/viewform'
  },
  {
    id: 2,
    title: 'STEMTronics Electronics Workshops',
    date: 'March 10 Wednesday, 2021',
    location: 'STEM Labs - Delkanda',
    description: 'Specially designed for covering electronics part in science of school syllabus.',
    image: stemWorkshop,
    link: 'https://docs.google.com/forms/d/e/1FAIpQLSeXmT0PRTwJDwA_LsqLzzG1Y_HtTbnJvXS2h_byP7hkBB4UcQ/viewform'
  },
  {
    id: 3,
    title: 'STEM Workshop',
    date: 'Pending...',
    location: 'Government School - Colombo 7',
    description: 'To inspiring innovation through school children.',
    image: schoolWorkshop,
    link: 'https://docs.google.com/forms/d/e/1FAIpQLSd0J5LDIzZnVGvzSi20-FFTQpkeRn-DL9qEO-Cx2TaMNnnK6g/viewform'
  },
  {
    id: 4,
    title: 'Fighting Robot Competition',
    date: 'Pending...',
    location: 'STEMLab - Delkanda',
    description: 'This Robot competition designed to develop the students programming skills.',
    image: robotCompetition,
    link: 'https://docs.google.com/forms/d/e/1FAIpQLScYwiG39kxW2fS-Cem154KUmeW44Vk0P9DK7ePdU3EkmxTWvA/viewform'
  },
  {
    id: 5,
    title: 'After O/L Robotics [Advanced] Course',
    date: 'Pending...',
    location: 'STEMLab - Delkanda',
    description: 'This course specially designed to develop innovation skills. 4 months certificate course.',
    image: olRobotics,
    link: 'https://docs.google.com/forms/d/e/1FAIpQLSfFoeyVlgf4pyU4aeF42Kxs1vgLq57Lst644KhkwNKvHC0UXA/viewform'
  },
  {
    id: 6,
    title: '3D Design & Printing Workshop',
    date: 'Pending...',
    location: 'STEMLab - Delkanda',
    description: 'In this session, students can get more knowledge about 3D design & Printing.',
    image: threeDesign,
    link: 'https://docs.google.com/forms/d/e/1FAIpQLSfO9d_kutN4JmUzDokFCTUjsiBCBrVrj16oe_0-hwVsO80pNQ/viewform'
  }
];

const EventsSection = () => {
  return (
    <section id="events" className="py-16">
      <div className="container">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <h2 className="text-2xl md:text-3xl font-extrabold mb-4 relative gradient-text animate-float text-center">
            <FaCalendarAlt className="inline-block mr-3 text-indigo-500" />
            Upcoming <span className="bg-clip-text text-transparent bg-gradient-to-r from-indigo-500 via-purple-500 to-pink-500 font-extrabold">Events</span>
          </h2>
          <div className="w-32 h-1 bg-gradient-to-r from-indigo-500 via-purple-500 to-pink-500 rounded-full animate-pulse mx-auto mb-4"></div>
  
          <Swiper
            modules={[Navigation]}
            spaceBetween={20}
            slidesPerView={1}
            breakpoints={{
              640: {
                slidesPerView: 1,
              },
              768: {
                slidesPerView: 2,
              }
            }}
            navigation
            className="events-swiper mt-6"
          >
            {events.map((event) => (
              <SwiperSlide key={event.id}>
                <motion.div 
                  className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-shadow duration-300"
                  whileHover={{ y: -5 }}
                >
                  <div className="flex flex-col md:flex-row">
                    <div className="md:w-1/3">
                      <img 
                        src={event.image}
                        alt={event.title}
                        className="h-full w-full object-cover"
                      />
                    </div>
                    <div className="p-5 md:w-2/3">
                      <h4 className="font-bold text-lg text-theme-blue mb-2">{event.title}</h4>
                      <div className="flex items-center text-gray-600 text-sm mb-1">
                        <FaCalendarAlt className="mr-2 text-theme-accent" />
                        <span>{event.date} |</span>
                      </div>
                      <div className="flex items-center text-gray-600 text-sm mb-3">
                        <FaMapMarkerAlt className="mr-2 text-theme-accent" />
                        <span>{event.location}</span>
                      </div>
                      <p className="text-gray-700 text-sm mb-4">{event.description}</p>
                      <a 
                        href={event.link}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="inline-flex items-center text-theme-accent hover:text-theme-blue transition-colors text-sm font-medium"
                      >
                        Register now <FaArrowRight className="ml-1" />
                      </a>
                    </div>
                  </div>
                </motion.div>
              </SwiperSlide>
            ))}
          </Swiper>
        </motion.div>
      </div>
    </section>
  );
};

export default EventsSection; 